export default __webpack_public_path__ + "static/media/plexusstrike3.da00fc68.png";